import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const PaymentSettingsScreen = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleEditSettings = () => {
    navigate("/edit-payment-settings");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="fixed top-0 left-0 right-0 z-20 bg-white px-4 py-3 flex items-center shadow-sm">
        <button
          type="button"
          onClick={handleBack}
          className="p-2 rounded-full hover:bg-gray-100 active:bg-gray-200"
          aria-label="Go back"
        >
          <IoArrowBack className="h-6 w-6 text-black" />
        </button>
        <h1 className="text-base font-semibold text-black flex-1 text-center">
          Payment Settings
        </h1>
        <div className="w-10" aria-hidden="true" />
      </header>

      <main className="pt-16 px-4 pb-6">
        <div className="bg-white rounded-lg p-4 mt-4">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Account Name
              </label>
              <div className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-gray-50">
                <span className="text-gray-900">John Doe</span>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Bank Name
              </label>
              <div className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-gray-50">
                <span className="text-gray-900">First Bank</span>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Account Number
              </label>
              <div className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-gray-50">
                <span className="text-gray-900">1234567890</span>
              </div>
            </div>

            <button
              type="button"
              onClick={handleEditSettings}
              className="w-full py-3 rounded-lg bg-[#19C463] text-white text-sm font-semibold mt-2"
            >
              Edit Account Details
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentSettingsScreen;
